import { Injectable, signal } from '@angular/core';
import { MessageContent } from '../models/agent.models';

@Injectable({
  providedIn: 'root',
})
export class ChatMonitorService {
  constructor() {
    console.log(`%c ChatMonitorService instantiated: ${Math.random()}`, 'color: #00ff00; font-weight: bold; padding: 2px 4px; border: 1px solid #00ff00;');
  }
  private readonly messageAudioWillPlay = signal<MessageContent | null>(null);
  public readonly messageAudioWillPlay$ = this.messageAudioWillPlay.asReadonly();

  public logMessageAudioWillPlay(message: MessageContent): void {
    console.log('Audio will play....', message);
    this.messageAudioWillPlay.set(message);
  }
}
